/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetFileRequest = {
  fileId: string;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

/** @internal */
export const GetFileRequest$inboundSchema: z.ZodType<
  GetFileRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  file_id: z.string(),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "file_id": "fileId",
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type GetFileRequest$Outbound = {
  file_id: string;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const GetFileRequest$outboundSchema: z.ZodType<
  GetFileRequest$Outbound,
  z.ZodTypeDef,
  GetFileRequest
> = z.object({
  fileId: z.string(),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    fileId: "file_id",
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function getFileRequestToJSON(getFileRequest: GetFileRequest): string {
  return JSON.stringify(GetFileRequest$outboundSchema.parse(getFileRequest));
}
export function getFileRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetFileRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetFileRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetFileRequest' from JSON`,
  );
}
